import riot from 'riot';
import events from '../src/events.js';
import { getActivityDetails as libGetActivityDetails, getActivityMonitors as libGetActivityMonitors } from '../src/lib.js';
riot.tag2('activity-dashboard', '<nav class="navbar" role="navigation" aria-label="main navigation" style="background-color: rgb(245,245,245); border-bottom: 1px solid #dbdbdb;"> <div class="navbar-brand"> <span class="navbar-item"> <span class="icon has-text-warning" style="margin-right: 0.4rem;"><i class="fas fa-chart-bar"></i></span> <span class="has-text-weight-semibold">Lesson Dashboard</span> </span> </div> <div class="navbar-menu is-active"> <div class="navbar-end"> <div class="navbar-item"> <div class="buttons"> <button class="button is-danger" onclick="{exitDashboardClick}"> <span class="icon is-small"><i class="fas fa-times"></i></span> <span>Close</span> </button> </div> </div> </div> </div> </nav> <div class="container is-fluid has-text-centered" show="{loading_activity_details && user}" style="margin-top: 5px;"> <progress class="progress is-large" max="100">60%</progress> </div> <div class="columns is-multiline" if="{!loading_activity_details && !selectedParticipant}" style="margin-top: 5px;"> <div class="column is-12"> <div class="card" style="display:flex; flex-direction:column; height:100%;"> <div class="card-content"> <div class="media"> <div class="media-left"> <figure class="image is-48x48"> <img riot-src="img/{parent.selectedActivity.lesson.icon}" alt="{parent.selectedActivity.lesson.name} Icon"> </figure> </div> <div class="media-content"> <p class="title is-4">{parent.selectedActivity.lesson.name}</p> <p class="subtitle is-6">Lesson Code: {detailedActivity.activity_ref}</p> </div> </div> <div class="content"> <div class="columns is-multiline" style="margin-top: .25rem;"> <div class="column is-6-desktop is-12-tablet"> <article class="message"> <div class="message-header"> <p>Devices</p> </div> <div class="message-body"> <div class="tags"> <span class="tag is-info is-light is-medium" each="{d in detailedActivity.device_ids}">{d}</span> </div> </div> </article> </div> <div class="column is-6-desktop is-12-tablet"> <article class="message"> <div class="message-header"> <p>Monitors</p> </div> <div class="message-body"> <monitors if="{!monitorsLoading}"></monitors> <div class="container is-fluid has-text-centered" show="{monitorsLoading}" style="margin-top: 5px;"> <progress class="progress is-large" max="100">60%</progress> </div> </div> </article> </div> </div> <article class="message" style="margin-top: .75rem;"> <div class="message-header"> <p>Participants ({detailedActivity.participants.length})</p> </div> <div class="message-body"> <div class="table-container"> <table class="table is-fullwidth is-striped is-hoverable" style="cursor: pointer;"> <thead> <tr class="has-background-light"> <th><abbr title="Participant">Participant Name</abbr></th> <th><abbr title="Filament">Filament</abbr></th> <th><abbr title="Progress">Overall Progress</abbr></th> <th><abbr title="Step">Current Step</abbr></th> <th><abbr title="Time">Time on Step</abbr></th> </tr> </thead> <tbody> <tr each="{p in detailedActivity.participants}" onclick="{participantClick}"> <td> <strong>{p.first_name} {p.last_name}</strong> </td> <td> <span class="tag is-info is-light">{p.progress.device}</span> </td> <td> <progress class="progress is-info" riot-value="{getParticipantCurrentStep(p)}" max="{getTotalSteps()}"></progress> </td> <td>{getParticipantStepLabel(p)}</td> <td>{prettyTimeSince(p.progress.timestamp)}</td> </tr> </tbody> </table> </div> </div> </article> </div> </div> </div> </div> </div> <participant-details if="{!loading_activity_details && selectedParticipant}"></participant-details>', '', '', function(opts) {
        var self = this;
        self.loading_activity_details = true;
        self.selectedParticipant = undefined;
        self.selectedActivity = undefined;
        self.detailedActivity = undefined;
        self.monitorsLoading = true;
        self.selectActivityDashHandler = undefined;

        self.selectActivityDashHandler = function(evtData) {
            const { selectedActivity, progressData, participant_id } = evtData;

            self.selectedActivity = selectedActivity;

            if (self.parent.auto_reload == undefined) {

                self.parent.auto_reload = setInterval(function() {
                    console.log("Auto Refresshing Dashboard ... ")
                    getActivityDetails();
                    getActivityMonitors(self.selectedActivity.activity_ref);
                }, 180 * 1000);
            }

            if (!self.detailedActivity) {
                getActivityDetails();
                getActivityMonitors(self.selectedActivity.activity_ref);
            } else {

                console.log("Details Loaded! Check for " + participant_id)
                if (!self.selectedParticipant && participant_id) {
                    getSelectedParticipantById(participant_id);
                    self.update();
                }
            }
        };

        events.on('select_activity_dash', self.selectActivityDashHandler);

        self.on('unmount', function() {
            if (self.selectActivityDashHandler) {
                events.off('select_activity_dash', self.selectActivityDashHandler);
            }
        });

        function getSelectedParticipantById(uid) {
            self.selectedParticipant = findParticipantById(uid, self.detailedActivity);
        }

        function findParticipantById(uid, activityData) {
            if (!uid || !activityData || !activityData.participants) {
                return undefined;
            }
            for (var i = 0; i < activityData.participants.length; i++) {
                if (activityData.participants[i].user_id == uid) {
                    return activityData.participants[i];
                }
            }
            return undefined;
        }

        function selectParticipantByIndex(index) {
            if (!self.detailedActivity || !self.detailedActivity.participants || self.detailedActivity.participants.length === 0) {
                return;
            }
            if (index < 0 || index >= self.detailedActivity.participants.length) {
                return;
            }

            self.selectedParticipant = self.detailedActivity.participants[index];
            self.update();
            route('activities/' + self.selectedActivity.activity_ref + '?view=dashboard&user_id=' + self.selectedParticipant.user_id, "Participant Details");
        }

        this.exitDashboardClick = function(e) {
            if (self.selectedParticipant) {
                self.selectedParticipant = undefined;
                route('activities/' + self.selectedActivity.activity_ref + "?view=dashboard", "Activity Management")
                self.update()
            } else {
                self.parent.unselectActivity()
            }
        }.bind(this)

        this.refreshDashboardClick = function(e) {
            self.loading_activity_details = true;
            self.update();
            getActivityDetails();
            getActivityMonitors(self.selectedActivity.activity_ref);
        }.bind(this)

        this.participantClick = function(e) {
            var participant = e.item.p;
            if (!participant || !participant.user_id || !self.detailedActivity || !self.detailedActivity.participants) {
                return;
            }
            for (var i = 0; i < self.detailedActivity.participants.length; i++) {
                if (self.detailedActivity.participants[i].user_id == participant.user_id) {
                    selectParticipantByIndex(i);
                    return;
                }
            }
        }.bind(this)

        this.getSelectedParticipantIndex = function() {
            if (!self.selectedParticipant || !self.selectedParticipant.user_id || !self.detailedActivity || !self.detailedActivity.participants) {
                return -1;
            }
            for (var i = 0; i < self.detailedActivity.participants.length; i++) {
                if (self.detailedActivity.participants[i].user_id == self.selectedParticipant.user_id) {
                    return i;
                }
            }
            return -1;
        }.bind(this)

        this.hasPreviousParticipant = function() {
            return this.getSelectedParticipantIndex() > 0;
        }.bind(this)

        this.hasNextParticipant = function() {
            var idx = this.getSelectedParticipantIndex();
            return idx > -1 && self.detailedActivity && self.detailedActivity.participants && idx < self.detailedActivity.participants.length - 1;
        }.bind(this)

        this.previousParticipantClick = function() {
            var idx = this.getSelectedParticipantIndex();
            if (idx > 0) {
                selectParticipantByIndex(idx - 1);
            }
        }.bind(this)

        this.nextParticipantClick = function() {
            var idx = this.getSelectedParticipantIndex();
            if (idx > -1 && self.detailedActivity && self.detailedActivity.participants && idx < self.detailedActivity.participants.length - 1) {
                selectParticipantByIndex(idx + 1);
            }
        }.bind(this)

        this.getSelectedParticipantPositionLabel = function() {
            var idx = this.getSelectedParticipantIndex();
            var total = self.detailedActivity && self.detailedActivity.participants ? self.detailedActivity.participants.length : 0;
            if (idx < 0 || total <= 0) {
                return '0 of 0';
            }
            return (idx + 1) + ' of ' + total;
        }.bind(this)

        this.getTotalSteps = function() {
            if (!self.parent || !self.parent.selectedActivity || !self.parent.selectedActivity.lesson || !self.parent.selectedActivity.lesson.steps) {
                return 0;
            }
            return self.parent.selectedActivity.lesson.steps.length;
        }.bind(this)

        this.getParticipantCurrentStep = function(p) {
            var total = this.getTotalSteps();
            var current = p && p.progress && p.progress.step !== undefined ? parseInt(p.progress.step, 10) : 0;
            if (isNaN(current)) current = 0;
            if (current < 0) current = 0;
            if (total <= 0) return 0;
            if (current > total) current = total;
            return current;
        }.bind(this)

        this.getParticipantStepLabel = function(p) {
            return 'Step ' + this.getParticipantCurrentStep(p) + ' of ' + this.getTotalSteps();
        }.bind(this)

        this.prettyTimeSince = function(epoch_ms) {

            let ns = Date.now();
            let diff = ns - epoch_ms;

            let mins = Math.round((diff / 1000) / 60)

            if (mins > 120 && mins < 4320) {

                return Math.round(mins / 60) + ' hours';
            } else if (mins >= 4320) {
                return Math.round(mins / 60 / 24) + ' days'
            } else {
                return mins + ' minutes';
            }

        }.bind(this)

        function getActivityDetails() {
            self.loading_activity_details = true;
            libGetActivityDetails(self.parent.selectedActivity.activity_ref).then(function(res) {
                self.loading_activity_details = false;
                var refreshedActivity = res['data']['activities'][0];
                var selectedParticipantId = self.selectedParticipant ? self.selectedParticipant.user_id : undefined;

                self.update({
                    detailedActivity: refreshedActivity
                });

                if (selectedParticipantId) {
                    self.selectedParticipant = findParticipantById(selectedParticipantId, refreshedActivity);
                    self.update();
                }

                route.exec();
            }).catch(function(error) {
                console.error('POST Activity Details Error:' + error);
                self.loading_activity_details = false;
                self.update({
                    activities: [],
                    error: error
                });
            });

        }

        function getActivityMonitors(actRef) {
            self.monitorsLoading = true;
            self.update();
            libGetActivityMonitors(actRef).then(function(res) {
                self.monitorsLoading = false;
                self.update({
                    monitors: res['data']['monitors'],
                    error: undefined
                });
            }).catch(function(error) {
                console.error('GET Monitors Error:' + error);
                self.monitorsLoading = false;
                self.update({
                    monitors: [],
                    error: error
                });
            });
        }
});
